export enum EditMenuScreen {
  MAIN = 'main',
  EDIT = 'edit',
}

export interface GetEditSubmenuOptions {
  isMobile?: boolean;
}

export interface CreditBadgeOptions {
  cost: number;
  isDisabled: boolean;
}
